import React,{Suspense,lazy} from "react";
import {Routes,Route} from "react-router-dom";

const Privateroute = lazy(() => import('./route/privateroute'));
const Publicroute  = lazy(() => import('./route/publicroute'));

const Panellayout = lazy(() => import('./layout/panel/panellayout'));

const Authlayout = lazy(() => import('./layout/auth/authlayout'));
const Validate = lazy(() => import('./pages/validate'));
const Nopage = lazy(() => import('./pages/nopage'));

const Dashboard = lazy(() => import('./pages/panel/dashboard/dashboard'));
const Pagenotfound = lazy(() => import('./pages/panel/pagenotfound/pagenotfound'));

const Region = lazy(() => import('./pages/panel/region/region'));
const Country = lazy(() => import('./pages/panel/country/country'));
const Location = lazy(() => import('./pages/panel/location/location'));
const State = lazy(() => import('./pages/panel/state/state'));
const Department = lazy(() => import('./pages/panel/department/department'))
const Designation = lazy(() => import('./pages/panel/designation/designation'))
const Entity = lazy(() => import('./pages/panel/entity/entity'))
const Employee = lazy(() => import('./pages/panel/employee/employee'))
const Currency = lazy(() => import('./pages/panel/currency/currency'));

const Client = lazy(() => import('./pages/panel/client/client'));
const Clientupdate = lazy(() => import('./pages/panel/clientupdate/clientupdate'));
const Clientaudit = lazy(() => import('./pages/panel/clientaudit/clientaudit'));
const Clientmsi = lazy(() => import('./pages/panel/clientmsi/clientmsi'));

const Vendor = lazy(() => import('./pages/panel/vendor/vendor'));
const Vendorupdate = lazy(() => import('./pages/panel/vendorupdate/vendorupdate'))
const Vendoraudit = lazy(() => import('./pages/panel/vendoraudit/vendoraudit'))
const Vendormsi = lazy(() => import('./pages/panel/vendormsi/vendormsi'))

const Candidate = lazy(() => import('./pages/panel/candidate/candidate'))
const Candidateupdate = lazy(() => import('./pages/panel/candidateupdate/candidateupdate'))
const Candidateaudit = lazy(() => import('./pages/panel/candidateaudit/candidateaudit'))

const Podetails = lazy(() => import('./pages/panel/podetails/podetails'))
const Poupdate = lazy(() => import('./pages/panel/poupdate/poupdate'))
const Agreement = lazy(() => import('./pages/panel/agreement/agreement'));
const AgreementUpdate = lazy(() => import('./pages/panel/agreementupdate/agreementupdate'));


const Candidatets = lazy(() => import('./pages/panel/candidatets/candidatets'))

const Grndetails = lazy(()=> import('./pages/panel/grndetails/grndetails'))
const Bills = lazy(() => import('./pages/panel/bills/bills'));

const Payvalidation = lazy(() => import('./pages/panel/payvalidation/payvalidation'))
const Invoice = lazy(() => import('./pages/panel/invoice/invoice'))
const Paypayroll = lazy(() => import('./pages/panel/paypayroll/paypayroll'));
const Paymentadvise = lazy(() => import('./pages/panel/paymentadvise/paymentadvise'))

const Payrolltsverify = lazy(() => import('./pages/panel/payrolltsverify/payrolltsverify'));
const Pedetails = lazy(() => import('./pages/panel/pedetails/pedetails'));
const Codocument = lazy(() => import('./pages/panel/codocument/codocument'));

const Poagreport = lazy(() => import('./pages/panel/poagreport/poagreport'));
const Ctsreport = lazy(() => import('./pages/panel/ctsreport/ctsreport'));
const Grnreport = lazy(() => import('./pages/panel/grnreport/grnreport'));
const Billsreport = lazy(() => import('./pages/panel/billsreport/billsreport'));

const Podetailsold = lazy(() => import('./pages/panel/podetails_old/podetails'))
const Swopo = lazy(() => import('./pages/panel/swopo/swopo'))
const Grnone = lazy(() => import('./pages/panel/grnone/grnone'))
const Grntwo = lazy(() => import('./pages/panel/grntwo/grntwo'))

const CandidateMailDetails = lazy(() => import('./pages/panel/candidatemaildetails/candidatemaildetails'));

const Ncandidates = lazy(() => import('./pages/npanel/ncandidates/ncandidates'));
const Nrecreport = lazy(() => import('./pages/npanel/nrecreport/nrecreport'));

const Newcandidate = lazy(() => import('./pages/npanel/newcandidate/newcandidate'));
const Newalcandidate = lazy(() => import('./pages/npanel/newalcandidate/newalcandidate'));
const Newamcandidate = lazy(() => import('./pages/npanel/newamcandidate/newamcandidate'));
const Newamdoccandidate = lazy(() => import('./pages/npanel/newamdoccandidate/newamdoccandidate.js'))

const Newcandidateapprove = lazy(() => import('./pages/npanel/newcandidateapprove/newcandidateapprove'))
const Newrecreport = lazy(() => import('./pages/npanel/newrecreport/newrecreport'));

const Newrecdaterep = lazy(() => import('./pages/npanel/newrecdaterep/newrecdaterep'));

const Newcanincentive = lazy(() => import('./pages/npanel/newcanincentive/newcanincentive'));

const Overallrecreport = lazy(() => import('./pages/npanel/overallrecreport/overallrecreport'));

const Rclient = lazy(() => import('./pages/npanel/rclient/rclient'));
const Rvendor = lazy(() => import('./pages/npanel/rvendor/rvendor'));

const Accountsection = lazy(() => import('./pages/npanel/accountsection/accountsection'))

// const Jobcreation = lazy(() => import('./pages/npanel/jobcreation/jobcreation'));

// const Joballemplist = lazy(() => import('./pages/npanel/joballocatedlist/joballocatedlist'))

const Jobcreation = lazy(() => import('./pages/npanel/jobcreation/jobcreation'));
const Joballemplist = lazy(() => import('./pages/npanel/joballocatedlist/joballocatedlist'));
const MyCandidateJobs = lazy(() => import('./pages/npanel/mycandidatejobs/mycandidatejobs'));

const Singlejobcreate = lazy(() => import('./pages/npanel/singlejobcreate/singlejobcreate'));
const Pooljobs = lazy(() => import('./pages/npanel/pooljobs/pooljobs'));
const Vat = lazy(() => import('./pages/panel/taxremainder/vat'));

const Managementreport = lazy(() => import('./pages/npanel/allnewreport/managementreport'));
const Datewisereport = lazy(() => import('./pages/npanel/allnewreport/datewisereport'));

const ExpenseApproval = lazy(() => import('./pages/panel/expenseapproval/expenseapproval.js'));

const Expenseentry = lazy(() => import('./pages/panel/expenseentry/expenselist.js'));
const Tracker = lazy(() => import('./pages/npanel/tracker/tracker.js'));
const Tasktracking = lazy(() => import('./pages/npanel/tasktracking/tasktracking.js'));
const Taskmaster = lazy(() => import('./pages/npanel/taskmaster/taskmaster.js'));

/** TESTING PART */
const Testclient = lazy(() => import('./pages/panel/testing/testclient/testclient'));
/** TESTING PART */
const Candidatedump = lazy(() => import('./pages/npanel/candidatedump/candidatedump.js'));
const Newalmcandidate = lazy(() => import('./pages/npanel/newalmcandidate/newamcandidate.js'));

const Payrollengine = lazy(() => import('./pages/npanel/payrollengine/payrollengine.js'));


/** Eupore Data */
const Eucandidate = lazy(() => import('./pages/eudata/eucandidate/eucandidate.js'));
const Eumargin = lazy(() => import('./pages/eudata/eumargin/eumargin.js'));
const Euinvoice = lazy(() => import('./pages/eudata/euinvoice/euinvoice.js'));
const Eubills = lazy(() => import('./pages/eudata/eubills/eubills.js'));
const Eupayroll = lazy(() => import('./pages/eudata/eupayroll/eupayroll.js'))

const Euinvoicereport = lazy(() => import('./pages/eudata/euinvoicereport/euinvoicereport.js'));
const Eubillreport = lazy(() => import('./pages/eudata/eubillreport/eubillreport.js'));
const Euoverallreport = lazy(() => import('./pages/eudata/euoverallreport/euoverallreport.js'))

const Eupayreport = lazy(() => import('./pages/eudata/eupayreport/eupayreport.js'));
const Euclientbill = lazy(() => import('./pages/eudata/euclientbill/euclientbill.js'));

const Dashregion = lazy(() => import('./pages/eudata/dashregion/dashregion.js'));

/** AU DATA */

const Auinvoice = lazy(() => import('./pages/audata/auinvoice/auinvoice.js'));
const Aubills = lazy(() => import('./pages/audata/aubills/aubills.js'));
const Aupayroll = lazy(() => import('./pages/audata/aupayroll/aupayroll.js'))

const Auinvoicereport = lazy(() => import('./pages/audata/auinvoicereport/auinvoicereport.js'));
const Aubillreport = lazy(() => import('./pages/audata/aubillreport/aubillreport.js'));
const Auoverallreport = lazy(() => import('./pages/audata/auoverallreport/auoverallreport.js'))

const Aupayreport = lazy(() => import('./pages/audata/aupayreport/aupayreport.js'));
const Auclientbill = lazy(() => import('./pages/audata/auclientbill/auclientbill.js'));


function App() {
  return (
    <>
      <Suspense fallback={<p>Loading...</p>}>
      <Routes>

        <Route element={<Publicroute />}>
          <Route path="/" element={<Authlayout><Validate /></Authlayout>} />
          <Route path="/:token" element={<Authlayout><Validate /></Authlayout>} />
        </Route>

        <Route element={<Privateroute />}>
          <Route path="/panel" element={<Panellayout/>}>
            
            <Route index element={<Dashboard />} />
            <Route path="panel" element={<Dashboard />} />
            <Route path="dashboard" element={<Dashboard />} />

            <Route path="eumargin/:page_id" element={<Eumargin />} />
            <Route path="eucandidate/:page_id" element={<Eucandidate />} />
            <Route path="euinvoice/:page_id" element={<Euinvoice />} />
            <Route path="eubills/:page_id" element={<Eubills />} />
            <Route path="eupayroll/:page_id" element={<Eupayroll />} />
            <Route path="euclientbill/:page_id" element={<Euclientbill />} />

            <Route path="euinvoicereport/:page_id" element={<Euinvoicereport />} />
            <Route path="eubillreport/:page_id" element={<Eubillreport />} />
            <Route path="Euoverallreport/:page_id" element={<Euoverallreport />} />
            <Route path="Eupayreport/:page_id" element={<Eupayreport />} />

            <Route path="dashregion/:page_id" element={<Dashregion />} />

            <Route path="auinvoice/:page_id" element={<Auinvoice />} />
            <Route path="aubills/:page_id" element={<Aubills />} />
            <Route path="aupayroll/:page_id" element={<Aupayroll />} />
            <Route path="auclientbill/:page_id" element={<Auclientbill />} />

            <Route path="auinvoicereport/:page_id" element={<Auinvoicereport />} />
            <Route path="aubillreport/:page_id" element={<Aubillreport />} />
            <Route path="auoverallreport/:page_id" element={<Auoverallreport />} />
            <Route path="aupayreport/:page_id" element={<Aupayreport />} />



            <Route path="region/:page_id" element={<Region />} />
            <Route path="country/:page_id" element={<Country />} />
            <Route path="location/:page_id" element={<Location />} />
            <Route path="state/:page_id" element={<State />} />
            <Route path="department/:page_id" element={<Department />} />
            <Route path="designation/:page_id" element={<Designation />} />
            <Route path="entity/:page_id" element={<Entity />} />
            <Route path="employee/:page_id" element={<Employee />} />
            <Route path="currency/:page_id" element={<Currency />} />
            <Route path="client/:page_id" element={<Client />} />
            <Route path="clientupdate/:page_id" element={<Clientupdate />} />
            <Route path="clientaudit/:page_id" element={<Clientaudit />} />
            <Route path="clientmsi/:page_id" element={<Clientmsi />} />

            <Route path="vendor/:page_id" element={<Vendor />} />
            <Route path="vendorupdate/:page_id" element={<Vendorupdate />} />
            <Route path="vendoraudit/:page_id" element={<Vendoraudit />} />
            <Route path="vendormsi/:page_id" element={<Vendormsi />} />

            <Route path="candidate/:page_id" element={<Candidate />} />
            <Route path="candidateupdate/:page_id" element={<Candidateupdate />} />
            <Route path="candidateaudit/:page_id" element={<Candidateaudit />} />

            <Route path="podetails/:page_id" element={<Podetails />} />
            <Route path="poupdate/:page_id" element={<Poupdate/>}/>
            <Route path="agreement/:page_id" element={<Agreement />} />
            <Route path="agreementupdate/:page_id" element={<AgreementUpdate />} />


            <Route path="candidatets/:page_id" element={<Candidatets />} />
            <Route path="grndetails/:page_id" element={<Grndetails />} />
            <Route path="bills/:page_id" element={<Bills />} />

            <Route path="payvalidation/:page_id" element={<Payvalidation />} />

            <Route path="invoice/:page_id" element={<Invoice />} />
            <Route path="paypayroll/:page_id" element={<Paypayroll />} />

            <Route path="paymentadvise/:page_id" element={<Paymentadvise />} />

            <Route path="poagreport/:page_id" element={<Poagreport />} />
            <Route path="ctsreport/:page_id" element={<Ctsreport />} />
            <Route path="grnreport/:page_id" element={<Grnreport />} />
            <Route path="billsreport/:page_id" element={<Billsreport />} />

            <Route path="podetailsold/:page_id" element={<Podetailsold />} />
            <Route path="podetails/:page_id" element={<Podetails />} />
            <Route path="swopo/:page_id" element={<Swopo />} />
            <Route path="grnone/:page_id" element={<Grnone />} />
            <Route path="grntwo/:page_id" element={<Grntwo />} />

            <Route path="payrolltsverify/:page_id" element={<Payrolltsverify />} />
            <Route path="pedetails/:page_id" element={<Pedetails />} />
            <Route path="codocument/:page_id" element={<Codocument />} />

            <Route path="ncandidates/:page_id" element={<Ncandidates />} />
            <Route path="nrecreport/:page_id" element={<Nrecreport />} />

            <Route path="newcandidate/:page_id" element={<Newcandidate />} />
            <Route path="newalcandidate/:page_id" element={<Newalcandidate />} />
            <Route path="newamcandidate/:page_id" element={<Newamcandidate />} />
            <Route path="newamdoccandidate/:page_id" element={<Newamdoccandidate />} />

            <Route path="newcandidateapprove/:page_id" element={<Newcandidateapprove />} />
            <Route path="newrecreport/:page_id" element={<Newrecreport />} />
            <Route path="newrecdaterep/:page_id" element={<Newrecdaterep />} />
            <Route path="newcanincentive/:page_id" element={<Newcanincentive />} />

            <Route path="overallrecreport/:page_id" element={<Overallrecreport />} />

            <Route path="rclient/:page_id" element={<Rclient />} />
            <Route path="rvendor/:page_id" element={<Rvendor />} />
            <Route path="taxremainder/:page_id" element={<Vat />} />

            <Route path="accountsection/:page_id" element={<Accountsection />} />

            {/* <Route path="jobcreation/:page_id" element={<Jobcreation />} />
            <Route path="joballocatedlist/:page_id" element={<Joballemplist />} /> */}

            <Route path="jobcreation/:page_id" element={<Jobcreation />} />
            <Route path="joballocatedlist/:page_id" element={<Joballemplist />} />
            <Route path="mycandidatejobs/:page_id" element={<MyCandidateJobs />} />

            <Route path="singlejobcreate/:page_id" element={<Singlejobcreate />} />
            <Route path="pooljobs/:page_id" element={<Pooljobs />} />


            {/* candidate mail details */}
             <Route path="candidatemaildetails/:page_id" element={<CandidateMailDetails />} />

            {/** TESTING PART */}
            <Route path="testclient/:page_id" element={<Testclient />} />
            {/** TESTING PART */}

            <Route path="payrollengine/:page_id" element={<Payrollengine />} />

            <Route path="managementreport/:page_id" element={<Managementreport />} />
            <Route path="datewisereport/:page_id" element={<Datewisereport />} />
            <Route path="expenseapproval/:page_id" element={<ExpenseApproval />} />
            <Route path="expenseentry/:page_id" element={<Expenseentry />} /> 
            <Route path="tracker/:page_id" element={<Tracker />} /> 
            <Route path="tasktracking/:page_id" element={<Tasktracking/>} />
            <Route path="taskmaster/:page_id" element={<Taskmaster />} />
            <Route path="candidatedump/:page_id" element={<Candidatedump />} />
            <Route path="newalmcandidate/:page_id" element={<Newalmcandidate />} />
            <Route path="*" element={<Pagenotfound />} />
          </Route>
        </Route>

        <Route path="*" element={<Authlayout><Nopage /></Authlayout>} />
      </Routes>
      </Suspense>
    </>
  );
}

export default App;
